import API from "@/classes/global/API";
import store from "@/store/index"
import Notification from "@/classes/component-classes/Notification";
import PickStockSaveDetail from "@/classes/models/PickStockSaveDetail";

export default class PickStockSave {

    constructor(pickStock) {

        this.pickStock = pickStock;
    }


    async handlePickSave() {

        let result = await API.savePickstockDetails(this.mapPickstockSaveDetail());

        if(result) {

            this.pickStock.pickedItems = result.pickedItems;
            this.pickStock.id = result.warehouse.id;

            this.pickStock.warehouseJobNumber = result.warehouse.whjobNumber;

            store.state.banners.success = new Notification(true, 'Address And Pick Details Saved');

        }

    }

    mapPickstockSaveDetail() {

        let detail = new PickStockSaveDetail();

        detail.id = this.pickStock.id;
        detail.whJobNumber = this.pickStock.warehouseJobNumber;
        detail.consigneeId = this.pickStock.consignee.id;
        detail.name = this.pickStock.consignee.name;
        detail.addressLine1 = this.pickStock.consignee.addressLine1;
        detail.addressLine2 = this.pickStock.consignee.addressLine2;
        detail.city = this.pickStock.consignee.city;
        detail.county = this.pickStock.consignee.county;
        detail.country = this.pickStock.consignee.country.split('-')[0] ?? '';
        detail.postCode = this.pickStock.consignee.postCode;
        detail.contactName = this.pickStock.consignee.selectedContact.value;
        detail.contactEmail = this.pickStock.consignee.selectedContact.email;
        detail.contactTelephone = this.pickStock.consignee.selectedContact.phone;
        detail.customerRef = this.pickStock.customerRef;
        detail.releaseDate = this.pickStock.releaseDate;
        detail.releaseTime = this.pickStock.releaseTime;
        detail.deliveryDate = this.pickStock.deliveryDate;
        detail.action = this.pickStock.action;
        detail.instructions = this.pickStock.deliveryInstructions;
        detail.pickedItems = this.pickStock.pickedItems;

        return detail;
    }

}